import { ReactNode } from "react";

import { Translate } from "@/app/application/Translate";
import CloseIcon from "@mui/icons-material/Close";
import {
	Box,
	Button,
	Divider,
	Drawer,
	Paper,
	Typography,
	styled,
} from "@mui/material";

type SettingsDrawerProps = {
	settingsOpen: boolean;
	closeSettings: () => void;
	children: ReactNode;
	zIndex?: number;
	anchor?: "left" | "right";
};

interface StyledDrawerPaperProps {
	zIndex?: number;
}

const StyledDrawerPaper = styled(Paper, {
	shouldForwardProp: (prop) => prop !== "zIndex",
})<StyledDrawerPaperProps>(({ zIndex }) => ({
	width: "400px",
	height: "100vh",
	padding: "2rem",
	display: "flex",
	flex: 1,
	flexDirection: "column",
	gap: "1rem",
	zIndex: zIndex,
	border: "0px solid transparent !important",
	"& .MuiBox-root:first-of-type": {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
	},
}));

const StyledSettingsDrawer = (props: SettingsDrawerProps) => {
	const {
		settingsOpen,
		closeSettings,
		children,
		zIndex,
		anchor = "right",
	} = props;

	return (
		<Drawer anchor={anchor} open={settingsOpen} onClose={closeSettings}>
			<StyledDrawerPaper zIndex={zIndex}>
				<Box>
					<Typography variant="h4" component="h4">
						<Translate String="Settings.Header">Settings</Translate>
					</Typography>
					<Button variant="text" onClick={closeSettings}>
						<CloseIcon fontSize="small" />
					</Button>
				</Box>
				<Divider />
				{children}
			</StyledDrawerPaper>
		</Drawer>
	);
};

export default StyledSettingsDrawer;
